<template>
    <div class="uk-text-center floating-badge-wrap">
        <span class="uk-badge floating-badge" v-bind:class="badgeClass">{{text}}</span>
    </div>
</template>

<script>
export default {
    props: ['text', 'badgeClass']
}
</script>
